module.exports = __webpack_public_path__ + "img/File-pdf.4b109fb8.svg";